import React, { useEffect, useState } from "react";
import { Box, Typography, Button, useMediaQuery, Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { IMAGES, WEB_COLORS } from "@/lib/constants";
import Arrows from "../carouselComponent/arrows";
import Carousel from "../carouselComponent/carousel";

const customerFeedback = [
  {
    name: "Lalji Soni",
    title:
      "It is a simple procedure. For financial emergencies, it is the best option. Thanks for their assistance. Adaptable and well-balanced. You can acquire an immediate loan transfer with Hero FinCorp.",
    image: IMAGES.custReview,
    stars: 5,
  },
  {
    name: "Savi Gupta",
    title:
      "It's a great appreciation for obtaining the best personal loan with the fewest papers necessary and promptly disbursing loan funds. I truly appreciate your assistance.",
    image: IMAGES.custReview,
    stars: 4,
  },
  {
    name: "Rashi Kohli",
    title:
      "Herofincorp has great funds for various purposes. I got the best personal loan offer compared to interest rates, terms, and fees for my best financial situation. Thanks for your assistance.",
    image: IMAGES.custReview,
    stars: 3,
  },
  {
    name: "Savi Gupta",
    title:
      "Herofincorp has great funds for various purposes. I got the best personal loan offer compared to interest rates, terms, and fees for my best financial situation. Thanks for your assistance.",
    image: IMAGES.custReview,
    stars: 4,
  },
  {
    name: "Rashi Kohli",
    title:
      "Herofincorp has great funds for various purposes. I got the best personal loan offer compared to interest rates, terms, and fees for my best financial situation. Thanks for your assistance.",
    image: IMAGES.custReview,
    stars: 5,
  },
  {
    name: "Rashi Kohli",
    title:
      "Herofincorp has great funds for various purposes. I got the best personal loan offer compared to interest rates, terms, and fees for my best financial situation. Thanks for your assistance.",
    image: IMAGES.custReview,
    stars: 4,
  },
  {
    name: "Savi Gupta",
    title:
      "Herofincorp has great funds for various purposes. I got the best personal loan offer compared to interest rates, terms, and fees for my best financial situation. Thanks for your assistance.",
    image: IMAGES.custReview,
    stars: 3,
  },
];

const FeedbackCarousel = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <Grid container sx={{ p: { xs: 2, md: 8 }, backgroundColor: "#fff" }}>
      <Grid container>
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            flexDirection: { xs: "row" },
            justifyContent: {
              xs: "space-between",
            },
            mb: 4,
          }}
        >
          <Box display={"flex"}>
            <Box
              width={10}
              sx={{
                background: "linear-gradient(to bottom, #00F200, #ffffff)", // Gradient from top to bottom
                borderRadius: "10px 10px 0 0", // Rounded top corners
                height: {
                  md: 200,
                  xs: 100,
                },
              }}
            ></Box>

            <Box px={2}>
              <Typography
                variant="h4"
                fontWeight="700"
                gutterBottom
                color={WEB_COLORS.darkTeal}
                sx={{
                  fontSize: {
                    xs: 20,
                    md: 40,
                  },
                  textTransform: {
                    md: "capitalize",
                  },
                }}
              >
                What our customers
                <br /> say about us.
              </Typography>
              <Typography
                color={"#3F3F3FCC"}
                fontWeight={400}
                sx={{
                  fontSize: {
                    xs: 12,
                    md: 18,
                  },
                }}
              >
                Get quick personal loans based on your career profile.
              </Typography>
            </Box>
          </Box>
          <Box sx={{ ml: { md: 4, xs: 0 } }}>
            <Arrows
              isPrevActive={activeIndex === 0 ? false : true}
              isNextActive={
                activeIndex === customerFeedback?.length - 1 ? false : true
              }
              prevSlide={() =>
                setActiveIndex(activeIndex < 1 ? 0 : activeIndex - 1)
              }
              nextSlide={() =>
                setActiveIndex(
                  activeIndex === customerFeedback?.length - 1
                    ? customerFeedback?.length - 1
                    : activeIndex + 1
                )
              }
            />
          </Box>
        </Grid>
        <Grid item xs={12} borderRadius={2}>
          <Carousel
            activeIndex={activeIndex}
            carouselSlides={customerFeedback}
            feedbackCard={true}
            showImages={false}
          ></Carousel>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FeedbackCarousel;
